import { IVideoRecallServiceInjectedProps, VideoRecallService } from '$State/VideoRecallFreezerService';
import { AlertTypes } from '$Utilities/Enums/AlertTypes';
import { useAppSnackbar } from '$Utilities/hooks/useAppSnackbar';
import { React } from 'Imports';
import { ConfirmDialog } from '$Components/Shared/ConfirmDialog';
import { isEncompass } from '$Utilities/integrationPlatform';

interface PromoteRecallDialogProps {
    videoEventId: number;
    open: boolean;
    onPromote: (eventId: number) => void;
    onClose: () => void;
}

const _PromoteRecallDialog = (props: PromoteRecallDialogProps & IVideoRecallServiceInjectedProps) => {
    const { showSnackbarMessage } = useAppSnackbar();

    const handleConfirmClick = async () => {
        try {
            await props.videoRecall.PromoteVideoRecall(props.videoEventId);
            showSnackbarMessage({
                message: `Video recall promoted successfully.`,
                alertType: AlertTypes.Success,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
        } catch (error) {
            showSnackbarMessage({
                message: `Unable to promote video recall.`,
                alertType: AlertTypes.Fail,
                isEncompass: isEncompass,
                showIcon: isEncompass,
            });
            props.onClose();
            return;
        }

        props.onPromote(props.videoEventId);
    };

    return (
        <ConfirmDialog
            isOpen={props.open}
            title={isEncompass ? 'Promote Video Recall' : 'Confirm Promote'}
            contentMessage="Are you sure you want to promote this video recall?"
            acceptButton="Promote"
            cancelButton="Cancel"
            isButtonAlert={false}
            handleModalClosed={props.onClose}
            handleSubmit={handleConfirmClick}
        />
    );
};

const PromoteRecallDialog = VideoRecallService.inject(_PromoteRecallDialog);

export default PromoteRecallDialog;
